"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deletePoll = deletePoll;
exports.editPollOptions = editPollOptions;
exports.editPollTitle = editPollTitle;
exports.likeReply = likeReply;
exports.likeTopic = likeTopic;
exports.markReplyAsNotSpam = markReplyAsNotSpam;
exports.markReplyAsSpam = markReplyAsSpam;
exports.markTopicAsSpam = markTopicAsSpam;
exports.moveToTopAnotherTopic = moveToTopAnotherTopic;
exports.moveToTopLevel = moveToTopLevel;
exports.pinReply = pinReply;
exports.reportReply = reportReply;
exports.reportTopic = reportTopic;
exports.unlikeReply = unlikeReply;
exports.unlikeTopic = unlikeTopic;
exports.unpinReply = unpinReply;
exports.unvoteIdea = unvoteIdea;
exports.voteIdea = voteIdea;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var _csrfToken = require("@insided/deprecated-preact-components/utils/csrfToken");

function reportTopic(_x, _x2, _x3, _x4) {
  return _reportTopic.apply(this, arguments);
}

function _reportTopic() {
  _reportTopic = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(userId, reason, contentType, topicId) {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(topicId, "/report"), {
              reason: reason
            });

          case 2:
            return _context.abrupt("return", _context.sent);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _reportTopic.apply(this, arguments);
}

function reportReply(_x5, _x6, _x7, _x8) {
  return _reportReply.apply(this, arguments);
}

function _reportReply() {
  _reportReply = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(userId, reason, contentType, replyId) {
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/replies/").concat(replyId, "/report"), {
              reason: reason
            });

          case 2:
            return _context2.abrupt("return", _context2.sent);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _reportReply.apply(this, arguments);
}

function markTopicAsSpam(_x9, _x10) {
  return _markTopicAsSpam.apply(this, arguments);
}

function _markTopicAsSpam() {
  _markTopicAsSpam = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(contentType, topicId) {
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(topicId, "/markAsSpam"));

          case 2:
            return _context3.abrupt("return", _context3.sent);

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _markTopicAsSpam.apply(this, arguments);
}

function deletePoll(_x11, _x12) {
  return _deletePoll.apply(this, arguments);
}

function _deletePoll() {
  _deletePoll = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(contentType, privateId) {
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _axios.default.delete("/community/api/".concat(contentType, "s/").concat(privateId, "/poll"), {
              data: {
                csrfToken: (0, _csrfToken.csrfToken)()
              }
            });

          case 2:
            return _context4.abrupt("return", _context4.sent);

          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _deletePoll.apply(this, arguments);
}

function editPollTitle(_x13, _x14, _x15) {
  return _editPollTitle.apply(this, arguments);
}

function _editPollTitle() {
  _editPollTitle = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(contentType, privateId, title) {
    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/editPollTitle"), {
              title: title
            });

          case 2:
            return _context5.abrupt("return", _context5.sent);

          case 3:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _editPollTitle.apply(this, arguments);
}

function editPollOptions(_x16, _x17, _x18) {
  return _editPollOptions.apply(this, arguments);
}

function _editPollOptions() {
  _editPollOptions = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(contentType, privateId, options) {
    return _regenerator.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/editPollOptions"), {
              options: options
            });

          case 2:
            return _context6.abrupt("return", _context6.sent);

          case 3:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _editPollOptions.apply(this, arguments);
}

function markReplyAsSpam(_x19, _x20) {
  return _markReplyAsSpam.apply(this, arguments);
}

function _markReplyAsSpam() {
  _markReplyAsSpam = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(contentType, replyId) {
    var shouldBanUser,
        _args7 = arguments;
    return _regenerator.default.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            shouldBanUser = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : true;
            _context7.next = 3;
            return _axios.default.post("/community/api/".concat(contentType, "s/replies/").concat(replyId, "/markAsSpam"), {
              banUser: shouldBanUser
            });

          case 3:
            return _context7.abrupt("return", _context7.sent);

          case 4:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _markReplyAsSpam.apply(this, arguments);
}

function markReplyAsNotSpam(_x21, _x22) {
  return _markReplyAsNotSpam.apply(this, arguments);
}

function _markReplyAsNotSpam() {
  _markReplyAsNotSpam = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(contentType, replyId) {
    return _regenerator.default.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/replies/").concat(replyId, "/markAsNotSpam"));

          case 2:
            return _context8.abrupt("return", _context8.sent);

          case 3:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _markReplyAsNotSpam.apply(this, arguments);
}

function voteIdea(_x23, _x24) {
  return _voteIdea.apply(this, arguments);
}

function _voteIdea() {
  _voteIdea = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9(topicId, currentUserId) {
    return _regenerator.default.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return _axios.default.post("/community/api/ideas/".concat(topicId, "/vote"), {
              votedBy: currentUserId
            });

          case 2:
            return _context9.abrupt("return", _context9.sent);

          case 3:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _voteIdea.apply(this, arguments);
}

function unvoteIdea(_x25, _x26) {
  return _unvoteIdea.apply(this, arguments);
}

function _unvoteIdea() {
  _unvoteIdea = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10(topicId, currentUserId) {
    return _regenerator.default.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return _axios.default.post("/community/api/ideas/".concat(topicId, "/unvote"), {
              unvotedBy: currentUserId
            });

          case 2:
            return _context10.abrupt("return", _context10.sent);

          case 3:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _unvoteIdea.apply(this, arguments);
}

function likeTopic(_x27, _x28, _x29) {
  return _likeTopic.apply(this, arguments);
}

function _likeTopic() {
  _likeTopic = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11(contentType, privateId, userId) {
    return _regenerator.default.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/like"), {
              likedBy: userId
            });

          case 2:
            return _context11.abrupt("return", _context11.sent);

          case 3:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _likeTopic.apply(this, arguments);
}

function unlikeTopic(_x30, _x31, _x32) {
  return _unlikeTopic.apply(this, arguments);
}

function _unlikeTopic() {
  _unlikeTopic = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12(contentType, privateId, userId) {
    return _regenerator.default.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/unlike"), {
              likedBy: userId
            });

          case 2:
            return _context12.abrupt("return", _context12.sent);

          case 3:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _unlikeTopic.apply(this, arguments);
}

function likeReply(_x33, _x34, _x35) {
  return _likeReply.apply(this, arguments);
}

function _likeReply() {
  _likeReply = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee13(contentType, privateReplyId, userId) {
    return _regenerator.default.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/replies/").concat(privateReplyId, "/like"), {
              likedBy: userId
            });

          case 2:
            return _context13.abrupt("return", _context13.sent);

          case 3:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _likeReply.apply(this, arguments);
}

function unlikeReply(_x36, _x37, _x38) {
  return _unlikeReply.apply(this, arguments);
}

function _unlikeReply() {
  _unlikeReply = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee14(contentType, privateReplyId, userId) {
    return _regenerator.default.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/replies/").concat(privateReplyId, "/unlike"), {
              likedBy: userId
            });

          case 2:
            return _context14.abrupt("return", _context14.sent);

          case 3:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
  return _unlikeReply.apply(this, arguments);
}

function pinReply(_x39, _x40) {
  return _pinReply.apply(this, arguments);
}

function _pinReply() {
  _pinReply = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee15(contentType, replyId) {
    return _regenerator.default.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            _context15.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/replies/").concat(replyId, "/pin"));

          case 2:
            return _context15.abrupt("return", _context15.sent);

          case 3:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
  return _pinReply.apply(this, arguments);
}

function unpinReply(_x41, _x42) {
  return _unpinReply.apply(this, arguments);
}

function _unpinReply() {
  _unpinReply = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee16(contentType, replyId) {
    return _regenerator.default.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _context16.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/replies/").concat(replyId, "/unpin"));

          case 2:
            return _context16.abrupt("return", _context16.sent);

          case 3:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));
  return _unpinReply.apply(this, arguments);
}

function moveToTopLevel(_x43, _x44) {
  return _moveToTopLevel.apply(this, arguments);
}

function _moveToTopLevel() {
  _moveToTopLevel = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee17(contentType, replyId) {
    return _regenerator.default.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            _context17.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/replies/").concat(replyId, "/moveToTopLevel"));

          case 2:
            return _context17.abrupt("return", _context17.sent);

          case 3:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));
  return _moveToTopLevel.apply(this, arguments);
}

function moveToTopAnotherTopic(_x45, _x46, _x47, _x48) {
  return _moveToTopAnotherTopic.apply(this, arguments);
}

function _moveToTopAnotherTopic() {
  _moveToTopAnotherTopic = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee18(contentType, replyId, destinationTopicId, destinationContentType) {
    return _regenerator.default.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            _context18.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/replies/").concat(replyId, "/move"), {
              topicType: destinationContentType,
              topicId: destinationTopicId
            });

          case 2:
            return _context18.abrupt("return", _context18.sent);

          case 3:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));
  return _moveToTopAnotherTopic.apply(this, arguments);
}